module.exports = __webpack_public_path__ + "img/Nachos.c591b104.webp";